import load from './load';
export var refresh = function refresh(options) {
  return function (dispatch) {
    return dispatch(load(options));
  };
};
export default refresh;